import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';

export default class CrumblePiece extends Phaser.GameObjects.Image {
  /**
   * 
   * @param {Phaser.Scene} scene 
   * @param {number} x 
   * @param {number} y 
   * @param {Phaser.GameObjects.Container} parent
   */
  constructor(scene, x, y, parent) {
    super(scene, x, y, ABCyaPhaser.Images.DEFAULT_ATLAS, 'piece+1');

    this.scene.physics.add.existing(this);
    this.body.immovable = true;
    this.body.enable = false;

    parent.add(this);
    this.active = false;
    this.visible = false;

    this.scene.events.on(Phaser.Scenes.Events.UPDATE, this.update, this);
    this.once(Phaser.GameObjects.Events.DESTROY, () => this.scene.events.off(Phaser.Scenes.Events.UPDATE, this.update, this));
  }

  spawn (x,y, pieceName, vx, vy, gravity) {
    this.setPosition(x, y);
    this.setFrame(pieceName);
    this.body.setSize();
    this.active = true;
    this.visible = true;
    this.body.enable = true;
    this.body.reset(this.x, this.y);
    this.body.setVelocity(vx, vy);
    this.body.gravity.y = gravity;
  }

  despawn () {
    this.active = false;
    this.visible = false;
    this.body.enable = false;
  }

  update () {
    if (this.active) {
      if (this.body.y > this.scene.scale.height || this.body.x < -50 || this.body.x > this.scene.scale.width + 50) {
        this.despawn();
      }
    }
  }
}